"use client";

import Image from "next/image";
import { Heading } from "@/components/ui/typography";

export default function ServiceCovers({ heading = "What Our Service Covers" }: { heading?: string } = {}) {
  const features = [
    "Monthly bookkeeping & classification",
    "Profits Tax Return filing support",
    "IRD correspondence management",
    "P&L and Balance Sheet preparation",
    "Audit preparation with CPA partners",
    "Annual Return submission",
    "Offshore claim documentation",
    "Deadline tracking & reminders",
  ];

  return (
    <section className="py-[30px] md:py-[60px] min-[1340px]:px-0 px-4">
      <div className="max-w-[1200px] mx-auto flex flex-col lg:flex-row gap-8 items-center">
        {/* LEFT CONTENT */}
        <div className="flex-1 flex flex-col gap-8">
          {/* Heading */}
          <div className="flex flex-col gap-6">
            <Heading as="h2" variant="section">
              {heading}
            </Heading>

            <p className="text-white/70 text-[16px] leading-[24px] font-medium">
              Your compliance plan includes everything required to keep your
              company active and filing-ready. Instead of managing multiple
              providers, everything stays coordinated through one system.
            </p>
          </div>

          {/* Features Grid */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
            {features.map((item, index) => (
              <div key={index} className="flex items-start gap-3">
                <svg
                  width="21"
                  height="21"
                  viewBox="0 0 21 21"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M6.64921 10.4499L9.49921 13.2999L15.1992 7.59994M10.4492 19.9499C11.697 19.9515 12.9328 19.7065 14.0856 19.229C15.2384 18.7515 16.2855 18.0509 17.1666 17.1674C18.0501 16.2862 18.7508 15.2391 19.2283 14.0863C19.7058 12.9335 19.9508 11.6977 19.9492 10.4499C19.9508 9.20215 19.7058 7.96635 19.2282 6.81355C18.7507 5.66075 18.0501 4.61368 17.1666 3.7325C16.2855 2.84902 15.2384 2.14838 14.0856 1.67086C12.9328 1.19334 11.697 0.948342 10.4492 0.949959C9.20142 0.948368 7.96562 1.19337 6.81282 1.67089C5.66002 2.14842 4.61294 2.84904 3.73177 3.7325C2.84831 4.61368 2.14768 5.66075 1.67016 6.81355C1.19264 7.96635 0.947636 9.20215 0.949227 10.4499C0.94761 11.6977 1.1926 12.9335 1.67013 14.0863C2.14765 15.2391 2.84829 16.2862 3.73177 17.1674C4.61294 18.0508 5.66002 18.7515 6.81282 19.229C7.96562 19.7065 9.20142 19.9515 10.4492 19.9499Z"
                    stroke="#155DFC"
                    strokeWidth="1.9"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>

                <p className="text-white text-[14px] leading-[150%]">
                  {item}
                </p>
              </div>
            ))}
          </div>
        </div>

        {/* RIGHT IMAGE */}
        <div className="flex-1 w-full">
          <div className="relative w-full h-[260px] sm:h-[320px] md:h-[420px] lg:h-[500px] rounded-2xl overflow-hidden">
            <Image
              src="/service-cover.webp"
              alt="Service preview"
              fill
              className="object-cover"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
